module.exports = __webpack_public_path__ + "static/media/dp-logo.a6398956.png";